module.exports = __webpack_public_path__ + "img/成都市第四人民医院.51e5b6b0.png";